module.exports = __webpack_public_path__ + "static/media/trenerska_prilezitost.36090f23.jpg";